import { RESET_ISSUE_STABLECOIN } from "../../types/pendings";

export const resetIssueStablecoin = () => ({
  type: RESET_ISSUE_STABLECOIN,
});
